import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_2 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_3 = { class: "p-the-header-navi-on-general__navi__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_NaviItemLinkForSpOnGeneral = _resolveComponent("NaviItemLinkForSpOnGeneral")!
  const _component_IconHistoryLog = _resolveComponent("IconHistoryLog")!

  return (_openBlock(), _createElementBlock("ul", null, [
    _createElementVNode("li", _hoisted_1, [
      _renderSlot(_ctx.$slots, "category")
    ]),
    _createElementVNode("li", _hoisted_2, [
      _createVNode(_component_NaviItemLinkForSpOnGeneral, {
        url: "/favorites/",
        label: "お気に入り"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24,
            "view-box": "0 0 24 24",
            "icon-color": _ctx.iconColor
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconHeart)
            ]),
            _: 1
          }, 8, ["icon-color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", _hoisted_3, [
      _createVNode(_component_NaviItemLinkForSpOnGeneral, {
        url: "/browser-history/",
        label: "閲覧履歴"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24,
            "view-box": "0 0 24 24",
            "icon-color": _ctx.iconColor
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconHistoryLog)
            ]),
            _: 1
          }, 8, ["icon-color"])
        ]),
        _: 1
      })
    ])
  ]))
}